import dayjs from "dayjs";
import { devices } from "../components/DeviceComponents";

// download pdf and csv files
export const downloadFile = ({ data, fileName, fileType }) => {
  const blob = new Blob([data], { type: fileType });
  const a = document.createElement("a");
  a.download = fileName;
  a.href = window.URL.createObjectURL(blob);
  const clickEvt = new MouseEvent("click", {
    view: window,
    bubbles: true,
    cancelable: true,
  });
  a.dispatchEvent(clickEvt);
  a.remove();
};

// date management
export const renderEUDate = (date) => {
  if (date === null || date === undefined) return "";
  const locale = Intl.DateTimeFormat().resolvedOptions().locale;

  return new Date(date).toLocaleDateString(locale, {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
};

export const renderEUTime = (date) => {
  if (date === null || date === undefined) return "";
  const locale = Intl.DateTimeFormat().resolvedOptions().locale;

  return new Date(date).toLocaleTimeString(locale, {
    hour: "2-digit",
    minute: "2-digit",
  });
};

export const renderEUDateTime = (date) => {
  if (date === null || date === undefined) return "";
  const locale = Intl.DateTimeFormat().resolvedOptions().locale;

  return new Date(date).toLocaleString(locale, {
    year: "numeric",
    month: "2-digit",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

export const convertServerToLocalDatetime = (date) => {
  if (date === null || date === undefined) return "";
  const locale = Intl.DateTimeFormat().resolvedOptions().locale;

  date = dayjs(date).add(1, "hour");
  return new Date(date).toLocaleString("en-US", {
    year: "numeric",
    month: "2-digit",
    day: "numeric",
    hour12: false,
    hour: "2-digit",
    minute: "2-digit",
  });
};

export const renderEUDateTimeLong = (date) => {
  const locale = Intl.DateTimeFormat().resolvedOptions().locale;

  return new Date(date).toLocaleString(locale, {
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: undefined,
  });
};

export const todayDate = () => {
  return dayjs().format("YYYY-MM-DD");
};

export const dateToServer = (date) => {
  const hoursOffset = new Date().getTimezoneOffset() / -60;

  let _date = new Date(date);

  _date.setTime(
    _date.getTime() +
      _date.getTimezoneOffset() * 60 * 1000 +
      hoursOffset * 60 * 60 * 1000
  );

  let data = `${_date.getFullYear()}-${
    _date.getMonth() + 1
  }-${_date.getDate()}`;

  return data;
};

export const datetimeToServer = (date) => {
  const hoursOffset = new Date().getTimezoneOffset() / -60;

  let _date = new Date(date);

  _date.setTime(
    _date.getTime() +
      _date.getTimezoneOffset() * 60 * 1000 +
      hoursOffset * 60 * 60 * 1000
  );

  return `${_date.getFullYear()}-${
    _date.getMonth() + 1
  }-${_date.getDate()} ${_date.getHours()}:${_date.getMinutes()}:00`;
};

export const renderDateUTC = (date) => {
  const d = new Date(date).toISOString().substring(0, 10);
  return d;
};
export const renderTimeUTC = (date) => {
  return new Date(date).toISOString().substring(11, 19);
};
export const renderDatetimeUTC = (date) => {
  return new Date(date).toISOString().replace("T", " ").substring(0, 19);
};

// returns the displayable version of the profile string (capitalized, no underscores)
export const prettify = (p) => {
  if (p !== null && p !== undefined) {
    let a = p.replace("_", " ");
    return a.charAt(0).toUpperCase() + a.replace("_", " ").slice(1);
  }
  return "null/undefined";
};

export const renderDeviceName = (device_type) => {
  return `${prettify(
    devices.find((el) => el.device_type === device_type).category
  )} / ${prettify(
    devices.find((el) => el.device_type === device_type).h3k_code
  )}`;
};

// toast options
export const toastError = {
  position: "bottom-left",
  autoClose: true,
  hideProgressBar: true,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: false,
  progress: undefined,
};

export const toastSuccess = {
  position: "bottom-left",
  autoClose: true,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: false,
  progress: undefined,
};
